import { hasLeadingSlash, resolveURL, withoutHost } from 'ufo';
import { useConfigurationStore } from '@/stores/configuration';
import { canParseAsUrl } from '@/utils/parse-url';

export function updateUrlPlaybackTime(src: string, time?: number) {
  if (!time || !canParseAsUrl(src)) return src;
  const url = new URL(src);
  url.hash = `t=${time}`;
  return url.toString();
}

export function getPreviewableUrl(src: string) {
  if (!canParseAsUrl(src)) return src;
  if (src.startsWith('blob:')) return src;

  if (src.includes('#t=0') || !src.includes('#t=')) return updateUrlPlaybackTime(src, 0.001);

  return src;
}

export function getSafeMediaUrl(src: Nullable<string>, baseUrl?: string): string {
  if (!src) return '';

  baseUrl ??= useConfigurationStore.getState().endpoint.FILE_ENDPOINT;

  if (!baseUrl) return src;
  if (src.startsWith('blob')) return src;
  if (src.startsWith('data')) return src;

  if (!src.startsWith('http')) {
    if (hasLeadingSlash(src)) return resolveURL(baseUrl, src);
    return src;
  }

  return resolveURL(baseUrl, withoutHost(src));
}

export function getPosterUrl(src: string, baseUrl?: string) {
  if (!canParseAsUrl(src)) return;

  const url = new URL(src);
  if (!url.protocol.startsWith('http')) return;

  const newPath = url.pathname.replace(/\..*$/, '.jpg') + url.search;

  return getSafeMediaUrl(new URL(newPath, url.origin).href, baseUrl);
}
